<template>
  <div style="padding-right: 10px;display: inline-block;vertical-align: middle;font-weight: bold;">
    <div style="display: flex;justify-content: space-between;font-size: 14px;">
      <template v-if="arResultList.length > 0">
        {{ arLabel }}
        <div v-for="(item,index) in arResultList" :key="'ar' + index">
          <div style="display: flex;align-content: center;padding-left: 5px;">
            <span style="font-weight: bold;font-size: 14px;">{{ item.currency }}({{ $t('CargoMsg.Cargo_AmountTo') }}):</span>
            <span style="padding-left: 3px;font-size: 14px;">{{ item.amount + (item.isEnd ? '' : ';') }}</span>
          </div>
        </div>
      </template>
      <template v-if="apResultList.length > 0">
        <span style="padding: 0 3px;" />{{ apLabel }}
        <div v-for="(item,index) in apResultList" :key="'ap' + index">
          <div style="display: flex;align-content: center;padding-left: 5px;">
            <span style="font-weight: bold;font-size: 14px;">{{ item.currency }}({{ $t('CargoMsg.Cargo_AmountTo') }}):</span>
            <span style="padding-left: 3px;font-size: 14px;">{{ item.amount + (item.isEnd ? '' : ';') }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'ChargeCurrencyTotalGroup',
  props: {
    arField: { type: String, default: 'receivable' }, // 收付字段
    currencyField: { type: String, default: 'currency' },
    dataField: { type: String, default: 'amount' },
    dataProvider: { type: Array, default: () => [] }, // 数据源
    arLabel: { type: String, default: '' },
    apLabel: { type: String, default: '' }
  },
  data() {
    return {
      arResultList: [],
      apResultList: []
    }
  },
  watch: {
    dataProvider() {
      this.groupingCalc()
    }
  },
  created() {
    this.groupingCalc()
  },
  methods: {
    groupingCalc() {
      const arResultList = []
      const apResultList = []
      const arCurrencyAmountObj = {}
      const apCurrencyAmountObj = {}
      const currencySet = new Set()
      for (const item of this.dataProvider) {
        const currencyAmountObj = item[this.arField] ? arCurrencyAmountObj : apCurrencyAmountObj
        const currency = item[this.currencyField]
        let amountSum = currencyAmountObj.hasOwnProperty(currency) ? currencyAmountObj[currency] : 0
        amountSum += item[this.dataField]
        currencyAmountObj[currency] = amountSum
        currencySet.add(currency)
      }
      const arCurrencyList = Object.keys(arCurrencyAmountObj).sort()
      const apCurrencyList = Object.keys(apCurrencyAmountObj).sort()
      for (const currency of arCurrencyList) {
        const amount = NumberUtils.ToFixed2(arCurrencyAmountObj[currency], 2)
        arResultList.push({ currency, amount, isEnd: false })
      }
      for (const currency of apCurrencyList) {
        const amount = NumberUtils.ToFixed2(apCurrencyAmountObj[currency], 2)
        apResultList.push({ currency, amount, isEnd: false })
      }
      if (apResultList.length > 0) {
        apResultList[apResultList.length - 1].isEnd = true
      } else {
        if (arResultList.length > 0) {
          arResultList[arResultList.length - 1].isEnd = true
        }
      }
      this.arResultList = arResultList
      this.apResultList = apResultList
    }
  }
}
</script>
